import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TablePurchaseComponent } from './table-purchase.component';
import {CardModule} from '../../components/card/card.module';
import {RouterModule} from '@angular/router';
import {SmartTableModule} from '../../modules/smart-table/smart-table.module';
import {MomentPipeModule} from '../../pipes/moment-pipe/moment-pipe.module';
import {BadgeExistModule} from '../../components/badge-exist/badge-exist.module';
import {IconsModule} from '../../components/icons/icons.module';
import {ReducerPipeModule} from '../../pipes/reducer-pipe/reducer-pipe.module';
import {NgxPopperModule} from 'ngx-popper';
import {PaginationModule} from '../../components/pagination/pagination.module';
import {PreloaderModule} from '../../components/preloader/preloader.module';
import {NumeralPipeModule} from '../../pipes/numeral-pipe/numeral-pipe.module';
import {EntityLinkModule} from "../../components/entity-link/entity-link.module";
import {UpperFirstPipeModule} from "../../pipes/upper-first-pipe/upper-first-pipe.module";
import {PortalModule} from "@angular/cdk/portal";
import {NgxJsonViewerModule} from 'ngx-json-viewer';
import {ModalReceiptsListModule} from '../../components/modals/modal-receipts-list/modal-receipts-list.module';
import { ModalConfirmModule } from '../../components/modals/modal-confirm/modal-confirm.module';



@NgModule({
  declarations: [TablePurchaseComponent],
  exports: [TablePurchaseComponent],
    imports: [
        CommonModule,
        CardModule,
        RouterModule,
        SmartTableModule,
        MomentPipeModule,
        BadgeExistModule,
        IconsModule,
        ReducerPipeModule,
        NgxPopperModule,
        PaginationModule,
        PreloaderModule,
        NumeralPipeModule,
        EntityLinkModule,
        UpperFirstPipeModule,
        PortalModule,
        NgxJsonViewerModule,
        ModalReceiptsListModule,
        ModalConfirmModule
    ]
})
export class TablePurchaseModule { }
